import { c as _c } from "react/compiler-runtime";
import EncryptedCell from '@/components/encrypted-cell';
export type FieldProps = {
  label: string;
  value: unknown;
  isDecrypted: boolean;
  isEmpty: boolean;
};
const Field = t0 => {
  const $ = _c(11);
  const {
    label,
    value,
    isDecrypted,
    isEmpty
  } = t0;
  let t1;
  if ($[0] !== isDecrypted || $[1] !== isEmpty || $[2] !== value) {
    t1 = () => {
      if (isDecrypted || isEmpty) {
        return <span className="text-body-2 text-right wrap-anywhere md:text-start md:wrap-normal" data-dd-privacy="mask">{typeof value === "string" ? value : "-"}</span>;
      }
      return <EncryptedCell />;
    };
    $[0] = isDecrypted;
    $[1] = isEmpty;
    $[2] = value;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const renderValue = t1;
  let t2;
  if ($[4] !== label) {
    t2 = <span className="text-body-2 text-tertiary wrap-anywhere md:wrap-normal">{label}</span>;
    $[4] = label;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== renderValue) {
    t3 = renderValue();
    $[6] = renderValue;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <div className="flex justify-between items-center gap-2">{t2}{t3}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export default Field;